import React from "react";
import { Link } from "react-router-dom";
import Site2Navbar from "../../Components/Site2Navbar/Site2Navbar";
import logo from "../../Assets/logo.png";

const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Vision", to: "/vision" },
  { label: "Services", to: "/services" },
  { label: "Our Team", to: "/activity" },
  { label: "Contact", to: "/contact" },
];


const Site2Footer = () => (
  <footer
    style={{
      backgroundColor: "#f9fafb",
      borderTop: "1px solid rgba(72, 31, 87, 0.1)",
    }}
    className="py-10 px-6"
  >
    <div className="max-w-6xl mx-auto">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8 mb-8">
        <div className="flex flex-col gap-3">
          <img
            src={logo}
            alt="Tarak Global Enterprises"
            style={{ height: "40px", width: "auto", objectFit: "contain", alignSelf: "flex-start" }}
          />
          <p className="text-gray-500 text-xs max-w-xs leading-6">
            Your trusted partner for global market entry, business growth, and
            strategic consulting.
          </p>
        </div>
        <div className="flex flex-wrap gap-6">
          {NAV_LINKS.map((l) => (
            <Link
              key={l.label}
              to={l.to}
              className="text-gray-600 text-sm hover:text-[#481F57] font-semibold transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </div>
        <div className="flex flex-col gap-2 text-xs text-gray-500">
          <a href="mailto:tarakglobal@gmail.com" className="hover:text-[#481F57] font-semibold transition-colors">tarakglobal@gmail.com</a>
          <a href="tel:+918605373028" className="hover:text-[#481F57] font-semibold transition-colors">+91 8605373028</a>
          <a
            href="https://www.linkedin.com/company/tarak-global-enterprises/"
            target="_blank"
            rel="noreferrer"
            className="hover:text-[#481F57] font-semibold transition-colors"
          >
            LinkedIn ↗
          </a>
        </div>
      </div>
      <div
        style={{ borderTop: "1px solid rgba(72, 31, 87, 0.08)" }}
        className="pt-6 text-center"
      >
        <p className="text-gray-400 text-xs">
          © {new Date().getFullYear()} Tarak Global Enterprises. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

const PageHeader = ({ tag, title, subtitle }) => (
  <section
    style={{
      background: "linear-gradient(135deg, #f5f3ff 0%, #fae8ff 100%)",
      borderBottom: "1px solid rgba(72, 31, 87, 0.08)",
    }}
    className="pt-32 pb-16 px-6 text-center"
  >
    <div className="max-w-3xl mx-auto">
      <span
        style={{ color: "#481F57", borderColor: "rgba(72, 31, 87, 0.3)" }}
        className="text-xs font-bold tracking-widest uppercase border rounded-full px-3 py-1 mb-4 inline-block"
      >
        {tag}
      </span>
      <h1 className="text-3xl sm:text-5xl font-extrabold text-[#481F57] mt-3 mb-4 leading-tight">
        {title}
      </h1>
      {subtitle && (
        <p className="text-gray-600 text-base sm:text-lg max-w-xl mx-auto leading-relaxed">
          {subtitle}
        </p>
      )}
    </div>
  </section>
);

const Site2Layout = ({ children, tag, title, subtitle }) => (
  <div style={{ fontFamily: "'Inter', 'Segoe UI', sans-serif", backgroundColor: "#ffffff", minHeight: "100vh" }}>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap" rel="stylesheet" />
    <Site2Navbar />
    <PageHeader tag={tag} title={title} subtitle={subtitle} />
    <main style={{ backgroundColor: "#ffffff" }}>{children}</main>
    <Site2Footer />
  </div>
);

export default Site2Layout;
